<div class="analytics-popup send-email-popup">
  <!-- <div class="modal-header p-0">
      <h2 mat-dialog-title>Send Email</h2>
      <button mat-icon-button mat-dialog-close class="btn-close-popups"></button>
  </div> -->
  <div class="modal-header pt-3 d-flex justify-content-between border-bottom">
    <div class="title-row p-0">
      <div class="inner-page-title">Send Email</div>
    </div>
    <button type="button" class="pull-right btn-close-popup" aria-label="Close" (click)="onClose()">
      <i class="ic-close"></i>
    </button>
  </div>

  <form name="emailListForm" [formGroup]="emailListForm" (ngSubmit)="sendEmail(emailListForm)">
    <div class="modal-body">
      <div class="home-reg-wrapper me-0 mt-3">
        <div class="home-reg-form">

          <div class="benefy-cmn-frm-sec">
              <div class="row">

                <div class="col-lg-12 mb-3">
                  <div class="form-group">
                    <label class="form-label">Email subject</label>
                    <input class="form-control" id="emailSubject" placeholder="Enter Email subject" type="text"
                      formControlName="emailSubject" />
                    <div class="validation-error" *ngIf="submitted && emailListForm.get('emailSubject').errors">
                      Email subject is required
                    </div>
                  </div>                
                </div>

                <div class="col-lg-12">
                  <div class="form-group">
                    <label class="form-label" for="recipientEmailsInput">Recipient emails</label>
                    <!-- <mat-form-field class="w-100" appearance="outline">
                      <mat-chip-list #chipList aria-label="Email selection">
                        <mat-chip *ngFor="let email of email_list" [selectable]="true" [removable]="true" (removed)="removeEmail(email)">
                          {{email}}
                          <span matChipRemove class="custom-cross">&times;</span>
                        </mat-chip>
                        
                        <input
                          placeholder="Enter the recipient emails"
                          [matChipInputFor]="chipList"
                          [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                          [matChipInputAddOnBlur]="true"
                          (matChipInputTokenEnd)="addEmail($event)"
                        />
                      </mat-chip-list>
                    </mat-form-field> -->
                                            
                      <mat-form-field appearance="outline" class="chip-list-form-field w-100">
                        <mat-chip-grid #chipGrid aria-label="Email selection">
                          <mat-chip-option *ngFor="let email of email_list"
                                          [selectable]="true"
                                          [removable]="true"
                                          (removed)="removeEmail(email)">
                            {{ email }}
                            <button matChipRemove>
                              <i class="fa fa-close"></i>
                            </button>
                          </mat-chip-option>

                          <input
                            id="recipientEmailsInput"
                            placeholder="Add email..."
                            [matChipInputFor]="chipGrid"
                            [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                            [matChipInputAddOnBlur]="true"
                            (matChipInputTokenEnd)="addEmail($event)" />
                        </mat-chip-grid>
                      </mat-form-field>

                    <div class="validation-error" *ngIf="submitted && email_list.length === 0">
                      Recipient emails is required
                    </div>
                  </div>
                </div>
          
                <div class="col-lg-12">
                  <angular-editor id="editor2" formControlName="emailContent" [config]="editorConfig"></angular-editor>
                  <div class="validation-error" *ngIf="submitted && emailListForm.get('emailContent').errors">Email content is required</div>
                </div>


              </div>
          </div>

        </div>
      </div>
    </div>
    <div class="modal-footer py-3">
      <button type="button" class="btn btn-default mr-2" (click)="decline()"> Cancel </button>
      <button class="btn-cmn btn-green" type="submit">
        ok
      </button>
    </div>

 </form>

</div>